// Rendered on user base template
import init, { initWidgets } from 'src/lib/init.js'
import { initSelectAll } from "src/lib/select-all"

import Vue from 'vue'
import rootComponent from '@/root/workgroups.js'
import 'src/styles/aristotle.table_browser.less'
import 'src/styles/aristotle.dashboard.less'
import 'src/styles/aristotle.workgroup.less'

new Vue(rootComponent)
initSelectAll()
init()

$(document).ready(function() {
    $('.modal').on('loaded.bs.modal', function() {
        initWidgets()
    })
})
